import graphql__e3799b709f1a7cfd7f02 from "./__generated__/ContributionsMapContributionMarker_contributionMarker.graphql.js";
import graphql__527b0b9b7f3d8e6b8f2a from "./__generated__/ContributionsMapContributionMarker_map.graphql.js";import { graphql, useFragment } from "react-relay";
import { Marker } from "react-leaflet";

import MapElementIcon from "../../../Maps/MapElementIcon";
import { useNavigateTo } from "../../../Routes/RoutesContext";
import ContributionsMapContributionTooltip from "./ContributionsMapContributionTooltip";

const ContributionsMapContributionMarker = props => {
  const contributionMarker = useFragment(
    ContributionsMapContributionMarker_contributionMarker,
    props.contributionMarker
  );
  const { latitude, longitude, contributionSlug, themeId } = contributionMarker;
  const position = latitude && longitude ? [latitude, longitude] : null;

  const map = useFragment(ContributionsMapContributionMarker_map, props.map);
  const { participativeModule, contributionsZIndexOffset: zIndexOffset } = map;
  const { slug: participativeModuleSlug } = participativeModule;

  // Fetch the theme from the participative module's theme list, which permits us not to
  // query too much data related to the themes from our contributions markers query, as
  // the themes data is also fetched by other map components, this doesn't add more data
  // loading as we require them from this component.
  const theme = participativeModule.themes.find(({ id }) => id === themeId);
  const iconStyle = { ...theme.style };

  const navigateTo = useNavigateTo();

  const handleMarkerClicked = () =>
    navigateTo("contribution", { participativeModuleSlug, contributionSlug });

  // Do not render unlocated contributions
  if (!position) return null;

  const icon = MapElementIcon({ iconStyle });

  return (
    <Marker
      className="map-debate-contribution"
      icon={icon}
      position={position}
      eventHandlers={{ click: handleMarkerClicked }}
      zIndexOffset={zIndexOffset}
    >
      <ContributionsMapContributionTooltip contributionMarker={contributionMarker} />
    </Marker>
  );
};

const ContributionsMapContributionMarker_contributionMarker = graphql__e3799b709f1a7cfd7f02;

const ContributionsMapContributionMarker_map = graphql__527b0b9b7f3d8e6b8f2a;

export default ContributionsMapContributionMarker;
